// extracted by mini-css-extract-plugin
module.exports = {"assortmentMenu":"AssortmentMenu_assortmentMenu__dc291","categoryNavigation":"AssortmentMenu_categoryNavigation__8a562","promoWrap":"AssortmentMenu_promoWrap__255d7"};